<div class="search-vacancy">
  <div class="top-container">
    <app-breadcrumbs></app-breadcrumbs>
    <div class="search-container">
      <div class="hero-copy">
        <h1 class="hero-title">
          {{ homeData()?.heroTitle || "Vind jouw volgende IT-uitdaging" }}
        </h1>
      </div>
      <div class="search-box">
        <app-search-box [form]="form" (submit)="search()"></app-search-box>
        @if (searchHistory.length > 0) {
          <div class="history">
            <div class="history-text">Recente zoekopdrachten</div>
            <div class="history-chips">
              @for (word of searchHistory; track word) {
                <button
                  class="chip"
                  (click)="setProfession(word)"
                  >
                  <span class="chip-text">{{ word }}</span>
                </button>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Decorative gradients/orbs -->
  <svg
    class="hero-orb orb-a"
    viewBox="0 0 400 400"
    aria-hidden="true"
    focusable="false"
    >
    <defs>
      <radialGradient id="orbGradientA" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#75b6e7" stop-opacity="0.6" />
        <stop offset="100%" stop-color="#75b6e7" stop-opacity="0" />
      </radialGradient>
    </defs>
    <circle cx="200" cy="200" r="200" fill="url(#orbGradientA)" />
  </svg>
  <svg
    class="hero-orb orb-b"
    viewBox="0 0 400 400"
    aria-hidden="true"
    focusable="false"
    >
    <defs>
      <radialGradient id="orbGradientB" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stop-color="#ffffff" stop-opacity="0.35" />
        <stop offset="100%" stop-color="#ffffff" stop-opacity="0" />
      </radialGradient>
    </defs>
    <circle cx="200" cy="200" r="200" fill="url(#orbGradientB)" />
  </svg>

  <!-- Subtle wave to transition into the content below -->
  <svg
    class="hero-wave"
    viewBox="0 0 1440 120"
    preserveAspectRatio="none"
    aria-hidden="true"
    focusable="false"
    >
    <path
      d="M0,40 C240,100 480,0 720,40 C960,80 1200,20 1440,60 L1440,120 L0,120 Z"
      fill="#f6f6f6"
    ></path>
  </svg>
</div>

<!-- Value Proposition & Stats -->
<section class="value-prop-stats-section animate-on-scroll animate-hidden">
  @if (showHomeSkeleton()) {
    <div class="value-prop-intro-container">
      <div
        class="skeleton-line skeleton-line--title"
        style="width: 60%; margin: 0 auto 1rem"
      ></div>
      <div
        class="skeleton-line skeleton-line--full"
        style="width: 80%; margin: 0 auto 0.5rem"
      ></div>
      <div
        class="skeleton-line skeleton-line--full"
        style="width: 75%; margin: 0 auto 0.5rem"
      ></div>
      <div
        class="skeleton-line skeleton-line--full"
        style="width: 70%; margin: 0 auto"
      ></div>
    </div>
    <div class="stats-container">
      @for (i of [1, 2, 3, 4]; track i) {
        <div class="stat-item">
          <div
            class="skeleton-line skeleton-line--title"
            style="width: 80px; height: 48px; margin: 0 auto 0.5rem"
          ></div>
          <div
            class="skeleton-line skeleton-line--text"
            style="width: 120px; height: 20px; margin: 0 auto"
          ></div>
        </div>
      }
    </div>
  } @else {
    <div class="value-prop-intro-container">
      <h2 class="value-prop-title">
        {{
        homeData()?.valuePropTitle ||
        "Klaar voor een volgende stap in jouw carrière?"
        }}
      </h2>
      <p class="value-prop-subtitle">
        {{
        homeData()?.valuePropSubtitle ||
        "Wij maken de connectie tussen jou en jouw nieuwe werkgever."
        }}
      </p>
      <p class="value-prop-text">
        {{
        homeData()?.valuePropText ||
        "Blauwtand is dé plek voor het verbinden van bedrijven en IT Professionals. Wij hebben voor jou de uitdagendste opties voor jouw volgende stap in de IT. Bij ons vind je wat je zoekt: een nieuwe baan of een nieuwe opdracht!"
        }}
      </p>
    </div>
    <div class="stats-container">
      @for (stat of stats(); track stat; let i = $index) {
        <div class="stat-item">
          <div class="stat-number">
            {{ getAnimatedStatDisplayValue(i) }}{{ stat.suffix }}
          </div>
          <div class="stat-label">{{ stat.label }}</div>
        </div>
      }
    </div>
  }
</section>

<!-- How It Works -->
<section class="how-it-works-section animate-on-scroll animate-hidden">
  <div class="how-it-works-container">
    @if (showHomeSkeleton()) {
      <div
        class="skeleton-line skeleton-line--title"
        style="width: 50%; margin: 0 auto 1rem"
      ></div>
      <div
        class="skeleton-line skeleton-line--text"
        style="width: 70%; margin: 0 auto 2rem"
      ></div>
    } @else {
      <h2 class="section-title">
        {{ homeData()?.howItWorksTitle || "Hoe werkt het?" }}
      </h2>
      <p class="section-subtitle">
        {{
        homeData()?.howItWorksSubtitle ||
        "In drie simpele stappen naar jouw volgende IT-uitdaging"
        }}
      </p>
      } @if (showHomeSkeleton()) {
      <div class="steps-grid">
        @for (i of [1, 2, 3]; track i) {
          <div class="step-card">
            <div
              class="skeleton-line"
          style="
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin: 0 auto 1rem;
          "
            ></div>
            <div
              class="skeleton-line skeleton-line--text"
              style="width: 60%; margin: 0 auto 0.5rem"
            ></div>
            <div
              class="skeleton-line skeleton-line--text"
              style="width: 90%; margin: 0 auto 0.5rem"
            ></div>
            <div
              class="skeleton-line skeleton-line--text"
              style="width: 80%; margin: 0 auto"
            ></div>
          </div>
        }
      </div>
    } @else {
      <div class="steps-grid">
        @for (step of howItWorksSteps(); track step; let i = $index) {
          <div
            class="step-card"
            >
            <div class="step-icon-wrapper" aria-hidden="true">
              <icon [name]="step.icon" class="step-icon"></icon>
            </div>
            <div class="step-number">{{ i + 1 }}</div>
            <div class="step-content">
              <h3 class="step-title">{{ step.title }}</h3>
              <p class="step-description">{{ step.description }}</p>
            </div>
          </div>
        }
      </div>
    }
  </div>
</section>

<!-- Split Hero: For Professionals -->
<div
  class="split-hero-wrapper split-hero-wrapper--gray animate-on-scroll animate-hidden"
  >
  <section class="split-hero split-hero--image-right">
    @if (showHomeSkeleton()) {
      <div class="split-hero__image">
        <div class="skeleton-image"></div>
      </div>
      <div class="split-hero__content">
        <div
          class="skeleton-line skeleton-line--title"
          style="width: 70%; margin-bottom: 1rem"
        ></div>
        <div
          class="skeleton-line skeleton-line--text"
          style="width: 90%; margin-bottom: 1.5rem"
        ></div>
        <div
          class="skeleton-line skeleton-line--full"
          style="margin-bottom: 0.5rem"
        ></div>
        <div
          class="skeleton-line skeleton-line--full"
          style="margin-bottom: 0.5rem"
        ></div>
        <div
          class="skeleton-line"
          style="width: 85%; margin-bottom: 0.5rem"
        ></div>
        <div class="skeleton-line" style="width: 80%; margin-bottom: 2rem"></div>
        <div
          class="skeleton-line"
          style="width: 180px; height: 48px; border-radius: 24px"
        ></div>
      </div>
    } @else {
      <div class="split-hero__image">
        <img
        [src]="
          homeData()?.professionalsImageUrl ||
          './assets/IMG_0686 - Bureau_sRGB.webp'
        "
          alt="IT Professionals aan het werk"
          loading="lazy"
          decoding="async"
          />
      </div>
      <div class="split-hero__content">
        <h2 class="split-hero__title">
          {{ homeData()?.professionalsTitle || "Voor IT Professionals" }}
        </h2>
        <h3 class="split-hero__subtitle">
          {{
          homeData()?.professionalsSubtitle ||
          "Vind een passende organisatie die matcht met jouw wensen en doelen"
          }}
        </h3>
        <div
          class="split-hero__text"
        [innerHTML]="
          homeData()?.professionalsText ||
          '<p>Wij kwalificeren jouw kennis en kunde niet puur en alleen op aantoonbare zaken (certificaten, diploma\'s of cursussen), maar zijn benieuwd naar de mens achter het CV.</p><p>Waar liggen jouw ambities en hoe kan of wil jij deze gaan bereiken? Wat is de ervaring die je al hebt? En welke organisatie zou jij aangeven als dé perfecte werkplek?</p><p>Neem gerust contact op met Wesley Boon - Recruitment Manager via <span class=&quot;link-container&quot;><icon name=&quot;whatsapp&quot;></icon><a class=&quot;link&quot; onclick=&quot;window.open(\'https://wa.me/31798080328\', \'_blank\')&quot;>+31 79 808 0328</a></span> of plan een eerste kennismaking in met één van de specialisten van Blauwtand.</p>'
        "
        ></div>
        <button class="apple-cta apple-cta--blue" (click)="routeTo('vacatures')">
          <span>{{
            homeData()?.professionalsCtaText || "Bekijk vacatures"
          }}</span>
          <icon name="navigate_next"></icon>
        </button>
      </div>
    }
  </section>
</div>

<!-- Split Hero: For Employers -->
<div
  class="split-hero-wrapper split-hero-wrapper--white animate-on-scroll animate-hidden"
  >
  <section class="split-hero split-hero--image-left">
    @if (showHomeSkeleton()) {
      <div class="split-hero__image">
        <div class="skeleton-image"></div>
      </div>
      <div class="split-hero__content">
        <div
          class="skeleton-line skeleton-line--title"
          style="width: 70%; margin-bottom: 1rem"
        ></div>
        <div
          class="skeleton-line skeleton-line--text"
          style="width: 90%; margin-bottom: 1.5rem"
        ></div>
        <div
          class="skeleton-line skeleton-line--full"
          style="margin-bottom: 0.5rem"
        ></div>
        <div
          class="skeleton-line skeleton-line--full"
          style="margin-bottom: 0.5rem"
        ></div>
        <div class="skeleton-line" style="width: 85%; margin-bottom: 2rem"></div>
        <div
          class="skeleton-line"
          style="width: 180px; height: 48px; border-radius: 24px"
        ></div>
      </div>
    } @else {
      <div class="split-hero__image">
        <img
        [src]="
          homeData()?.employersImageUrl ||
          './assets/IMG_0869 - Scrumboard_sRGB.webp'
        "
          alt="Werkgevers vinden talent"
          loading="lazy"
          decoding="async"
          />
      </div>
      <div class="split-hero__content">
        <h2 class="split-hero__title">
          {{ homeData()?.employersTitle || "Voor Werkgevers" }}
        </h2>
        <h3 class="split-hero__subtitle">
          {{
          homeData()?.employersSubtitle ||
          "Verkrijg de profielen van de best passende IT Professional op jouw vacature"
          }}
        </h3>
        <div
          class="split-hero__text"
        [innerHTML]="
          homeData()?.employersText ||
          '<p>Op zoek naar een IT professional? Maar weet je niet waar je de juiste talenten voor jouw organisatie kunt vinden? Wij zijn het juiste adres voor jou!</p><p>Bij Blauwtand vind je de échte connectie met IT Professionals die matchen met jouw eisen en wensen.</p>'
        "
        ></div>
        <button class="apple-cta apple-cta--blue" (click)="routeTo('employers')">
          <span>{{ homeData()?.employersCtaText || "Voor werkgevers" }}</span>
          <icon name="navigate_next"></icon>
        </button>
      </div>
    }
  </section>
</div>

<!-- Featured Jobs -->
<section class="featured-jobs-section animate-on-scroll animate-hidden">
  <div class="featured-jobs-container">
    @if (showHomeSkeleton()) {
      <div class="section-header">
        <div
          class="skeleton-line skeleton-line--title"
          style="width: 50%; margin-bottom: 0"
        ></div>
        <div
          class="skeleton-line"
          style="width: 200px; height: 44px; border-radius: 22px"
        ></div>
      </div>
      <div class="jobs-grid">
        @for (i of [1, 2, 3]; track i) {
          <div class="job-card">
            <div
              class="skeleton-line skeleton-line--text"
              style="width: 80%; margin-bottom: 1rem"
            ></div>
            <div
              class="skeleton-line skeleton-line--text"
              style="width: 50%; margin-bottom: 1rem"
            ></div>
            <div
              class="skeleton-line skeleton-line--full"
              style="margin-bottom: 0.5rem"
            ></div>
            <div
              class="skeleton-line"
              style="width: 90%; margin-bottom: 1.5rem"
            ></div>
            <div
              class="skeleton-line"
              style="width: 150px; height: 40px; border-radius: 20px"
            ></div>
          </div>
        }
      </div>
      <div
        class="skeleton-line"
        style="width: 200px; height: 44px; border-radius: 22px; margin: 0 auto"
      ></div>
    } @else {
      <app-featured-jobs-list
        [jobs]="featuredJobs"
        [title]="homeData()?.featuredJobsTitle || 'Uitgelichte vacatures'"
        [ctaLabel]="homeData()?.featuredJobsCtaText || 'Bekijk alle vacatures'"
        [ctaHref]="['/vacatures']">
      </app-featured-jobs-list>
    }
  </div>
</section>

<!-- Blog Preview -->
<section class="blog-preview-section animate-on-scroll animate-hidden">
  <div class="blog-preview-container">
    @if (showHomeSkeleton()) {
      <div class="section-header">
        <div
          class="skeleton-line skeleton-line--title"
          style="width: 40%; margin-bottom: 0"
        ></div>
        <div
          class="skeleton-line"
          style="width: 200px; height: 44px; border-radius: 22px"
        ></div>
      </div>
      <div class="blog-grid">
        @for (i of [1, 2, 3]; track i) {
          <div class="blog-preview-card">
            <div class="blog-preview-image">
              <div class="skeleton-image" style="height: 100%"></div>
            </div>
            <div class="blog-preview-content">
              <div
                class="skeleton-line"
            style="
              width: 80px;
              height: 24px;
              border-radius: 12px;
              margin-bottom: 1rem;
            "
              ></div>
              <div
                class="skeleton-line skeleton-line--text"
                style="width: 90%; margin-bottom: 0.5rem"
              ></div>
              <div
                class="skeleton-line skeleton-line--text"
                style="width: 85%; margin-bottom: 1rem"
              ></div>
              <div
                class="skeleton-line skeleton-line--full"
                style="margin-bottom: 0.5rem"
              ></div>
              <div
                class="skeleton-line"
                style="width: 80%; margin-bottom: 1rem"
              ></div>
              <div class="skeleton-line" style="width: 100px; height: 20px"></div>
            </div>
          </div>
        }
      </div>
      <div
        class="skeleton-line"
        style="width: 200px; height: 44px; border-radius: 22px; margin: 0 auto"
      ></div>
    } @else {
      <div class="section-header">
        <h2 class="section-title">
          {{ homeData()?.blogSectionTitle || "Laatste stories" }}
        </h2>
        <button
          class="apple-cta apple-cta--blue section-header__btn"
          (click)="routeTo('stories')"
          >
          <span>{{
            homeData()?.blogSectionCtaText || "Bekijk alle stories"
          }}</span>
          <icon name="navigate_next"></icon>
        </button>
      </div>
      <div class="blog-grid">
        @for (blog of recentBlogs; track blog) {
          <div
            class="blog-preview-card"
            (click)="routeToBlog(blog.slug)"
            style="cursor: pointer"
            >
            <div
              class="blog-preview-image"
          [style.background-image]="
            blog.coverImageUrl
              ? 'url(' + blog.coverImageUrl + ')'
              : 'url(/assets/IMG_0686 - Bureau_sRGB.webp)'
          "
            ></div>
            <div class="blog-preview-content">
              @if (blog.categories && blog.categories.length > 0) {
                <div
                  class="blog-category-chip"
                  >
                  {{ blog.categories[0].name }}
                </div>
              }
              <h3 class="blog-preview-title">
                {{ blog.title }}
              </h3>
              @if (blog.excerpt) {
                <p class="blog-preview-excerpt">
                  {{ blog.excerpt }}
                </p>
              }
              <button
                class="text-link"
                (click)="routeToBlog(blog.slug); $event.stopPropagation()"
                >
                <span>Lees meer</span>
                <icon name="navigate_next"></icon>
              </button>
            </div>
          </div>
        }
      </div>
      <button
        class="apple-cta apple-cta--blue section-footer__btn"
        (click)="routeTo('stories')"
        >
        <span>{{ homeData()?.blogSectionCtaText || "Bekijk alle stories" }}</span>
        <icon name="navigate_next"></icon>
      </button>
    }
  </div>
</section>

<!-- Testimonials -->
<section class="testimonials-section animate-on-scroll animate-hidden">
  <div class="testimonials-container">
    @if (showHomeSkeleton()) {
      <div
        class="skeleton-line skeleton-line--title"
        style="width: 60%; margin: 0 auto 2rem"
      ></div>
    } @else {
      <h2 class="section-title">
        {{
        homeData()?.testimonialsTitle ||
        "Wat zeggen professionals en bedrijven?"
        }}
      </h2>
      } @if (showHomeSkeleton()) {
      <div class="testimonials-carousel">
        <button
          class="carousel-btn carousel-btn--prev"
          disabled
          aria-label="Vorige testimonial"
          >
          <icon name="navigate_next" style="transform: rotate(180deg)"></icon>
        </button>
        <div class="testimonial-card">
          <div class="testimonial-quote">
            <div
              class="skeleton-line skeleton-line--full"
              style="margin-bottom: 0.5rem"
            ></div>
            <div
              class="skeleton-line skeleton-line--full"
              style="margin-bottom: 0.5rem"
            ></div>
            <div class="skeleton-line" style="width: 70%"></div>
          </div>
          <div class="testimonial-author">
            <div
              class="skeleton-line"
              style="width: 48px; height: 48px; border-radius: 50%"
            ></div>
            <div class="author-info">
              <div
                class="skeleton-line skeleton-line--text"
                style="width: 120px; margin-bottom: 0.25rem"
              ></div>
              <div
                class="skeleton-line skeleton-line--text"
                style="width: 150px"
              ></div>
            </div>
          </div>
        </div>
        <button
          class="carousel-btn carousel-btn--next"
          disabled
          aria-label="Volgende testimonial"
          >
          <icon name="navigate_next"></icon>
        </button>
      </div>
    } @else {
      <div class="testimonials-carousel">
        <button
          class="carousel-btn carousel-btn--prev"
          (click)="prevTestimonial()"
          aria-label="Vorige testimonial"
          >
          <icon name="navigate_next" style="transform: rotate(180deg)"></icon>
        </button>
        <div
          class="testimonial-card"
          [style.min-height.px]="testimonialCardMinHeight() || null"
          >
          <div class="testimonial-quote">
            <p>{{ testimonials()[currentTestimonialIndex].text }}</p>
          </div>
          <div class="testimonial-author">
            <icon
              [name]="testimonials()[currentTestimonialIndex].avatar"
              class="author-avatar"
            ></icon>
            <div class="author-info">
              <div class="author-name">
                {{ testimonials()[currentTestimonialIndex].name }}
              </div>
              @if (
                testimonials()[currentTestimonialIndex].role ||
                testimonials()[currentTestimonialIndex].company
                ) {
                <div
                  class="author-role"
                  >
                  @if (testimonials()[currentTestimonialIndex].role) {
                    <span>{{
                      testimonials()[currentTestimonialIndex].role
                    }}</span>
                  }
                  @if (
                    testimonials()[currentTestimonialIndex].role &&
                    testimonials()[currentTestimonialIndex].company
                    ) {
                    <span
                      >
                      bij
                    </span>
                  }
                  @if (testimonials()[currentTestimonialIndex].company) {
                    <span>{{
                      testimonials()[currentTestimonialIndex].company
                    }}</span>
                  }
                </div>
              }
            </div>
          </div>
        </div>
        <button
          class="carousel-btn carousel-btn--next"
          (click)="nextTestimonial()"
          aria-label="Volgende testimonial"
          >
          <icon name="navigate_next"></icon>
        </button>
      </div>
      <div class="carousel-controls-mobile">
        <button
          class="carousel-btn carousel-btn--prev"
          (click)="prevTestimonial()"
          aria-label="Vorige testimonial"
          >
          <icon name="navigate_next" style="transform: rotate(180deg)"></icon>
        </button>
        <button
          class="carousel-btn carousel-btn--next"
          (click)="nextTestimonial()"
          aria-label="Volgende testimonial"
          >
          <icon name="navigate_next"></icon>
        </button>
      </div>
      <div class="testimonial-dots">
        @for (testimonial of testimonials(); track testimonial; let i = $index) {
          <button
            class="dot"
            [class.dot--active]="i === currentTestimonialIndex"
            (click)="currentTestimonialIndex = i"
            [attr.aria-label]="'Ga naar testimonial ' + (i + 1)"
          ></button>
        }
      </div>
      <div class="testimonial-measure-container" aria-hidden="true">
        @for (testimonial of testimonials(); track testimonial) {
          <div
            #testimonialMeasureCard
            class="testimonial-card testimonial-card--measure"
            >
            <div class="testimonial-quote">
              <p>{{ testimonial.text }}</p>
            </div>
            <div class="testimonial-author">
              <icon [name]="testimonial.avatar" class="author-avatar"></icon>
              <div class="author-info">
                <div class="author-name">
                  {{ testimonial.name }}
                </div>
                @if (testimonial.role || testimonial.company) {
                  <div
                    class="author-role"
                    >
                    @if (testimonial.role) {
                      <span>{{ testimonial.role }}</span>
                    }
                    @if (testimonial.role && testimonial.company) {
                      <span>
                        bij
                      </span>
                    }
                    @if (testimonial.company) {
                      <span>{{ testimonial.company }}</span>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</section>

<!-- FAQ -->
<section class="faq-section animate-on-scroll animate-hidden">
  <div class="faq-container">
    @if (showHomeSkeleton()) {
      <div
        class="skeleton-line skeleton-line--title"
        style="width: 50%; margin: 0 auto 2rem"
      ></div>
    } @else {
      <app-faq-block
        [title]="homeData()?.faqTitle || 'Veelgestelde vragen'"
        [items]="faqItems()">
      </app-faq-block>
    }
  </div>
</section>

<!-- Final CTA -->
<section class="final-cta-section">
  <div class="final-cta-container">
    @if (showHomeSkeleton()) {
      <div
        class="skeleton-line skeleton-line--title"
        style="width: 50%; margin: 0 auto 1rem"
      ></div>
      <div
        class="skeleton-line skeleton-line--text"
        style="width: 70%; margin: 0 auto 2rem"
      ></div>
      <div class="final-cta-buttons">
        <div
          class="skeleton-line"
          style="width: 200px; height: 56px; border-radius: 28px"
        ></div>
        <div
          class="skeleton-line"
          style="width: 200px; height: 56px; border-radius: 28px"
        ></div>
      </div>
    } @else {
      <h2 class="final-cta-title">
        {{ homeData()?.ctaTitle || "Klaar om te beginnen?" }}
      </h2>
      <p class="final-cta-subtitle">
        {{
        homeData()?.ctaSubtitle ||
        "Vind vandaag nog jouw volgende IT-uitdaging of de perfecte kandidaat voor jouw organisatie."
        }}
      </p>
      <div class="final-cta-buttons">
        <button
          class="apple-cta apple-cta--blue apple-cta--large"
          (click)="routeTo('vacatures')"
          >
          <span>{{ homeData()?.ctaPrimaryButtonText || "Zoek vacatures" }}</span>
          <icon name="search"></icon>
        </button>
        <button class="apple-cta apple-cta--large" (click)="routeTo('employers')">
          <span>{{
            homeData()?.ctaSecondaryButtonText || "Voor werkgevers"
          }}</span>
          <icon name="navigate_next"></icon>
        </button>
      </div>
    }
  </div>
</section>
